import { useCallback } from "react";
import { useDispatch } from "react-redux";
//Local files
import { fillTemplatesActions } from 'features/fillTemplates';

const useFillTemplates = () => {
  const dispatch = useDispatch();
  const getFillTemplates = useCallback(({ offset }) => dispatch(fillTemplatesActions.getFillTemplates({ offset })), [dispatch]);
  const getFillTemplate = useCallback((id) => dispatch(fillTemplatesActions.getFillTemplate(id)), [dispatch]);
  const createFillTemplate = useCallback(fillTemplate => dispatch(fillTemplatesActions.createFillTemplate(fillTemplate)), [dispatch]);
  const updateFillTemplate = useCallback(fillTemplate => dispatch(fillTemplatesActions.updateFillTemplate(fillTemplate)), [dispatch]);
  const deleteFillTemplate = useCallback(id => dispatch(fillTemplatesActions.deleteFillTemplate(id)), [dispatch]);
  const clearLocalFillTemplates = useCallback(() => dispatch(fillTemplatesActions.clearLocalFillTemplates()), [dispatch]);
  const clearLocalActiveFillTemplate = useCallback(() => dispatch(fillTemplatesActions.clearLocalActiveFillTemplate()), [dispatch]);

  return { 
    getFillTemplates, 
    getFillTemplate, 
    createFillTemplate, 
    updateFillTemplate, 
    deleteFillTemplate, 
    clearLocalFillTemplates, 
    clearLocalActiveFillTemplate 
  };
};

export default useFillTemplates;